var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTkLegendA3De(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "a3",
    width: 1587.402,
    height: "297mm",
    viewBox: "0 0 1190.551 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect2",
    d: "M0 0h1190.551v841.89H0z",
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "rand",
    transform: "translate(1.85 .207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1034",
    d: "M74.627 788.31h656.542c1.29 0 2.334 1.224 2.334 2.735v25.487c0 1.51-1.045 2.736-2.334 2.736H74.627Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text503",
    x: 77.825,
    y: 814.526,
    style: {
      fontSize: 6,
      fontFamily: "SBBWeb-Roman,&quot"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan84313",
    x: 77.825,
    y: 814.526
  }, "Quelle: OpenStreetMap contributors \xA9 SBB/CFF/FFS www.tra\uFB01mage.ch www.geops.ch"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text105827",
    x: 78.083,
    y: 798.215,
    style: {
      fontSize: 6,
      lineHeight: 1,
      fontFamily: "SBBWeb-Roman,&quot"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan127563",
    x: 78.083,
    y: 798.215
  }, "Auf gewissen Autobuslinien ist ein Zuschlag und/oder eine Platzreservierung erforderlich. Bitte beachten Sie zudem, dass vom 21. M\xE4rz bis zum 31. Oktober f\xFCr Velos in InterCity (IC)-Z\xFCgen eine Veloplatzreservation obligatorisch ist.")), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan127565",
    x: 78.083,
    y: 804.215
  }, "Bitte beachten Sie die Hinweise f\xFCr die gew\xFCnschte Verbindung im (Online-)Fahrplan. Aus Platzgr\xFCnden sind, je nach Zoomstufe, nicht alle Linien angegeben. Alle Angaben ohne Gew\xE4hr. \xC4nderungen vorbehalten. Es gilt der Anwendungsbereich.")))), /*#__PURE__*/React.createElement("g", {
    id: "qr-code"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect23865",
    d: "M22.453 768.451h51.024v51.024H22.453z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23867",
    d: "M23.91 769.91h1.459v1.457H23.91Zm1.459 0h1.457v1.457H25.37zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0H31.2v1.457h-1.458zm1.458 0h1.458v1.457H31.2zm1.458 0h1.457v1.457h-1.457Zm5.83 0h1.459v1.457h-1.458zm2.917 0h1.457v1.457h-1.457zm5.83 0h1.459v1.457h-1.458zm4.374 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457H57.44Zm4.374 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457H64.73zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H70.56zm-46.65 1.457h1.458v1.458H23.91Zm8.747 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm5.831 0h1.458v1.458h-1.458zm8.747 0h1.458v1.458H70.56zm-46.65 1.458h1.458v1.458H23.91Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm8.747 0h1.457v1.458h-1.457zm10.204 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H70.56zm-46.65 1.458h1.458v1.457H23.91Zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0H31.2v1.457h-1.458zm2.916 0h1.457v1.457h-1.457Zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H37.03zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H44.32zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457Zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm4.374 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457H64.73zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457H70.56zm-46.65 1.457h1.458v1.458H23.91Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm4.373 0h1.458v1.458H37.03zm10.205 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H57.44Zm4.374 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H70.56zm-46.65 1.458h1.458v1.458H23.91Zm8.747 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm5.83 0h1.459v1.458h-1.458zm1.459 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm8.747 0h1.458v1.458H70.56zm-46.65 1.458h1.458v1.458H23.91Zm1.458 0h1.457v1.458H25.37zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458H44.32zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H70.56zm-33.53 1.458h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H44.32zm2.916 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-30.614 1.458h1.458v1.458H23.91Zm1.458 0h1.457v1.458H25.37zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm7.289 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H57.44Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.457H23.91Zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457H31.2zm4.373 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457H44.32zm2.916 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457H57.44Zm4.374 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H70.56zm-46.65 1.457h1.458v1.458H23.91Zm8.747 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-43.734 1.458h1.457v1.458H25.37zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458H31.2zm2.915 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.457zm5.83 0h1.459v1.458h-1.458zm7.29 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-43.734 1.458h1.458v1.458H23.91Zm1.458 0h1.457v1.458H25.37zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm4.374 0h1.457v1.458h-1.457Zm8.746 0h1.458v1.458H57.44Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm-40.818 1.458h1.457v1.458H25.37zm1.457 0h1.458v1.458h-1.458zm2.916 0H31.2v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm11.663 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H57.44Zm4.374 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H70.56zm-45.192 1.458h1.457v1.457H25.37zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0H31.2v1.457h-1.458zm2.916 0h1.457v1.457h-1.457Zm1.457 0h1.458v1.457h-1.458zm4.374 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457H44.32zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm7.289 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457H64.73zm4.373 0h1.458v1.457h-1.458zm-45.192 1.457h1.458v1.458H23.91Zm7.289 0h1.458v1.458H31.2zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-43.734 1.458h1.458v1.458H23.91Zm1.458 0h1.457v1.458H25.37zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458H31.2zm1.458 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H57.44Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H64.73zm4.373 0h1.458v1.458h-1.458zm-43.734 1.458h1.457v1.458H25.37zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458H57.44Zm4.374 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H70.56zm-42.277 1.458h1.458v1.458h-1.458zm2.916 0h1.458v1.458H31.2zm1.458 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458H23.91Zm1.458 0h1.457v1.458H25.37zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458H31.2zm13.12 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H57.44Zm1.458 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm-43.734 1.458h1.458v1.457H23.91Zm1.458 0h1.457v1.457H25.37zm1.457 0h1.458v1.457h-1.458zm2.916 0H31.2v1.457h-1.458zm1.458 0h1.458v1.457H31.2zm1.458 0h1.457v1.457h-1.457Zm5.83 0h1.459v1.457h-1.458zm1.459 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H44.32zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457Zm7.289 0h1.457v1.457h-1.457zm2.915 0h1.458v1.457h-1.458zm5.832 0h1.457v1.457H64.73zm4.373 0h1.458v1.457h-1.458zm-45.192 1.457h1.458v1.458H23.91Zm1.458 0h1.457v1.458H25.37zm2.915 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458H57.44Zm4.374 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H70.56zm-46.65 1.458h1.458v1.458H23.91Zm4.373 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm7.289 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458H23.91Zm5.831 0H31.2v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm5.831 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458H57.44Zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-43.734 1.458h1.458v1.458H23.91Zm4.373 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm4.374 0h1.457v1.458h-1.457Zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H57.44Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458H70.56zm-34.988 1.458h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm4.374 0h1.458v1.457h-1.458zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm4.373 0h1.458v1.457h-1.458zm5.832 0h1.457v1.457H64.73zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457H70.56zm-46.65 1.457h1.458v1.458H23.91Zm1.458 0h1.457v1.458H25.37zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm4.374 0h1.457v1.458h-1.457zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H57.44Zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458H23.91Zm8.747 0h1.457v1.458h-1.457Zm4.373 0h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm2.915 0h1.458v1.458h-1.458zm5.832 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H70.56Zm-46.65 1.458h1.458v1.458H23.91Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H37.03zm1.458 0h1.458v1.458h-1.458zm4.373 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H51.61zm4.374 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.458H23.91Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457Zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458H57.44Zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458H64.73zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm-43.734 1.458h1.458v1.458H23.91Zm2.915 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm7.289 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H57.44Zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm2.915 0h1.458v1.458h-1.458zm2.916 0h1.458v1.458h-1.458zm-45.192 1.458h1.458v1.457H23.91Zm8.747 0h1.457v1.457h-1.457Zm2.915 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457H37.03zm1.458 0h1.458v1.457h-1.458zm2.916 0h1.457v1.457h-1.457zm5.83 0h1.459v1.457h-1.458zm4.374 0h1.458v1.457h-1.458zm2.916 0h1.458v1.457h-1.458zm1.458 0h1.457v1.457h-1.457zm4.373 0h1.458v1.457h-1.458zm4.374 0h1.457v1.457H64.73zm1.457 0h1.458v1.457h-1.458zm1.458 0h1.458v1.457h-1.458zm-43.734 1.457h1.458v1.458H23.91Zm1.458 0h1.457v1.458H25.37zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458h-1.458zm1.458 0H31.2v1.458h-1.458zm1.458 0h1.458v1.458H31.2zm1.458 0h1.457v1.458h-1.457Zm2.915 0h1.458v1.458h-1.458zm4.374 0h1.458v1.458h-1.458zm1.458 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458h-1.458zm1.458 0h1.458v1.458H44.32zm1.458 0h1.458v1.458h-1.458zm2.916 0h1.457v1.458h-1.457Zm7.289 0h1.457v1.458h-1.457zm1.457 0h1.458v1.458H57.44Zm1.458 0h1.458v1.458h-1.458zm7.29 0h1.457v1.458h-1.458zm2.915 0h1.458v1.458h-1.458z",
    style: {
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "sbb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect22814",
    d: "M971.83 22.677h196.044v22.94H971.83z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect397399",
    d: "M973.281 23.927h192.107v20.659H973.281z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2879",
    d: "M973.28 44.374h60.703V24.139h-60.702v20.235Z",
    style: {
      fill: "#e42328",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2881",
    d: "M1009.012 32.708h6.564v-5.196h3.091v5.196h6.563l-5.28-5.196h3.918l6.745 6.745-6.745 6.744h-3.92l5.28-5.196h-6.56v5.196h-3.093v-5.196h-6.563l5.28 5.196h-3.916l-6.744-6.744 6.744-6.745h3.917",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2883",
    d: "M1040.247 36.972c-.039 3.492 2.896 5.04 6.03 5.04 3.848 0 5.891-1.944 5.891-4.543 0-3.212-3.173-3.867-4.205-4.123-3.55-.913-4.224-1.052-4.224-2.142 0-1.19 1.15-1.606 2.143-1.606 1.488 0 2.698.435 2.796 2.143h3.015c0-3.273-2.717-4.561-5.672-4.561-2.559 0-5.296 1.388-5.296 4.285 0 2.658 2.122 3.471 4.226 4.026 2.082.554 4.203.813 4.203 2.339 0 1.448-1.666 1.766-2.757 1.766-1.666 0-3.133-.735-3.133-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2885",
    d: "M1057.203 29.933h2.915c1.11 0 2.143.277 2.143 1.626 0 1.19-.814 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.741h6.861c2.559 0 5-1.23 5-4.106 0-1.764-.875-3.094-2.6-3.59a3.106 3.106 0 0 0 1.926-2.956c0-2.637-1.826-3.51-4.524-3.51h-6.663v14.162Zm3.113-6.307h3.39c1.329 0 2.241.576 2.241 2.023 0 1.467-1.07 1.865-2.3 1.865h-3.33",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2887",
    d: "M1071.14 29.933h2.916c1.11 0 2.142.277 2.142 1.626 0 1.19-.813 1.686-1.904 1.686h-3.154v-3.312Zm-3.113 11.741h6.861c2.56 0 4.998-1.23 4.998-4.106 0-1.764-.872-3.094-2.598-3.59a3.106 3.106 0 0 0 1.924-2.956c0-2.637-1.824-3.51-4.522-3.51h-6.663v14.162Zm3.115-6.307h3.39c1.33 0 2.242.576 2.242 2.023 0 1.467-1.07 1.865-2.3 1.865h-3.331",
    style: {
      fill: "#221e20",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2889",
    d: "M1099.666 32.272c-.377-3.272-2.994-5.096-6.108-5.096-4.384 0-6.96 3.273-6.96 7.477 0 4.086 2.576 7.358 6.96 7.358 3.471 0 5.91-2.26 6.227-5.792h-3.016c-.237 1.865-1.308 3.173-3.211 3.173-2.796 0-3.849-2.38-3.849-4.74 0-2.479 1.053-4.86 3.849-4.86 1.546 0 2.896 1.071 3.094 2.479",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2891",
    d: "M1101.702 41.674h3.114v-5.851h5.93v-2.42h-5.93v-3.272h6.842v-2.617h-9.956",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2893",
    d: "M1113.551 41.674h3.105v-5.851h5.924v-2.42h-5.926v-3.272h6.835v-2.617h-9.938",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2895",
    d: "M1130.233 41.674h3.122v-5.851h5.924v-2.42h-5.924v-3.272h6.834v-2.617h-9.955",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2897",
    d: "M1142.457 41.674h3.104v-5.851h5.924v-2.42h-5.924v-3.272h6.852v-2.617h-9.957",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2899",
    d: "M1153.554 36.972c-.035 3.492 2.89 5.04 6.031 5.04 3.854 0 5.889-1.944 5.889-4.543 0-3.212-3.177-3.867-4.194-4.123-3.55-.913-4.228-1.052-4.228-2.142 0-1.19 1.141-1.606 2.142-1.606 1.48 0 2.695.435 2.801 2.143h2.998c0-3.273-2.712-4.561-5.656-4.561-2.57 0-5.3 1.388-5.3 4.285 0 2.658 2.124 3.471 4.23 4.026 2.07.554 4.193.813 4.193 2.339 0 1.448-1.66 1.766-2.748 1.766-1.678 0-3.14-.735-3.14-2.62",
    style: {
      fill: "#221e20",
      strokeWidth: 0
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "title"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path523",
    d: "M-.224 22.677h388.448c.933 0 1.69.787 1.69 1.754v55.983c0 .97-.757 1.755-1.69 1.755H-.224Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text745",
    x: 22.102,
    y: 48.444,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 18,
      fontFamily: "SBBWeb-Light,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan24356",
    x: 22.102,
    y: 48.444
  }, "Spartageskarten / Aktionstageskarte /")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan24358",
    x: 22.102,
    y: 70.944
  }, "Spartageskarte Gemeinde ohne Halbtax-Abo")))), /*#__PURE__*/React.createElement("g", {
    id: "legend",
    transform: "translate(0 -27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect426128-0-8-3-9-2",
    width: 196.237,
    height: 122.401,
    x: 15.117,
    y: 117.193,
    rx: 2.551,
    ry: 2.382,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "scaleline",
    transform: "translate(0 -9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect2491",
    d: "M22.815 226.519h135.509v13.898H22.815Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "text2343",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text756",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(88.55 236.294)"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan750",
    x: 0,
    y: 0
  }, "50")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan752",
    x: 9.731,
    y: 0,
    style: {
      letterSpacing: ".00342em"
    }
  }, "k"), _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan754",
    x: 13.388,
    y: 0
  }, "m")))), /*#__PURE__*/React.createElement("path", {
    id: "path1881",
    d: "M175.435 226.52v13.371l-152.168.074V226.52",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".9031px",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g777"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text763",
    x: 22.21,
    y: 154.043,
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan761",
    x: 22.21,
    y: 154.043
  }, "Bahnen"))), /*#__PURE__*/React.createElement("g", {
    id: "g775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line765",
    d: "M23.628 142.724h32.28",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g795"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text781",
    x: 121.817,
    y: 154.128,
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan779",
    x: 121.817,
    y: 154.128
  }, "Seilbahnen"))), /*#__PURE__*/React.createElement("g", {
    id: "g793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line783",
    d: "M122.891 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g838",
    transform: "translate(-50.12 -7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7-1",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text809",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(171.621 196.83)"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan797",
    x: 0,
    y: 0
  }, "G\xFCl")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan799",
    x: 10.76,
    y: 0,
    style: {
      letterSpacing: "-.0127em"
    }
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan801",
    x: 12.875,
    y: 0,
    style: {
      letterSpacing: "-.00146em"
    }
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan803",
    x: 14.42,
    y: 0,
    style: {
      letterSpacing: "-.00293em"
    }
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan805",
    x: 18.419,
    y: 0,
    style: {
      letterSpacing: "-.0249em"
    }
  }, "k"), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan807",
    x: 21.878,
    y: 0
  }, "eit"))), /*#__PURE__*/React.createElement("text", {
    id: "text827",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot"
    },
    transform: "translate(171.621 205.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan811",
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.02296em"
    }
  }, "v"), _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan813",
    x: 3.339,
    y: 0
  }, "or O")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan815",
    x: 16.953,
    y: 0,
    style: {
      letterSpacing: ".03128em"
    }
  }, "r"), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan817",
    x: 19.503,
    y: 0
  }, "t")), _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan819",
    x: 0,
    y: 8.4
  }, "anf")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan821",
    x: 9.724,
    y: 8.4,
    style: {
      letterSpacing: "-.00345em"
    }
  }, "ra"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan823",
    x: 15.764,
    y: 8.4,
    style: {
      letterSpacing: "-.00099em"
    }
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan825",
    x: 19.777,
    y: 8.4,
    style: {
      letterSpacing: "-7e-05em"
    }
  }, "en"))), /*#__PURE__*/React.createElement("g", {
    id: "g836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line830",
    d: "M172.523 185.415v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line832",
    d: "M175.457 185.415h27.878",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3,
      strokeDasharray: "0,0,0,2.93449"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line834",
    d: "M204.802 185.415v0",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "round",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g866"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text852",
    x: 171.621,
    y: 154.128,
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan840",
    x: 171.621,
    y: 154.128,
    style: {
      letterSpacing: ".00049em"
    }
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan842",
    x: 176.16,
    y: 154.128,
    style: {
      letterSpacing: "-.00342em"
    }
  }, "c"), _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan844",
    x: 179.896,
    y: 154.128
  }, "hi")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan846",
    x: 185.344,
    y: 154.128,
    style: {
      letterSpacing: ".02344em"
    }
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan848",
    x: 187.58,
    y: 154.128,
    style: {
      letterSpacing: "-.01904em"
    }
  }, "f"), _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan850",
    x: 189.517,
    y: 154.128
  }, "e"))), /*#__PURE__*/React.createElement("g", {
    id: "g864"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line854",
    d: "M172.523 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g904"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text880",
    x: 72.072,
    y: 154.042,
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan868",
    x: 72.072,
    y: 154.042,
    style: {
      letterSpacing: "-.00586em"
    }
  }, "A"), _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan870",
    x: 76.567,
    y: 154.042
  }, "u")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan872",
    x: 80.46,
    y: 154.042,
    style: {
      letterSpacing: "-.02246em"
    }
  }, "t"), _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan874",
    x: 82.507,
    y: 154.042
  }, "obu")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan876",
    x: 94.569,
    y: 154.042,
    style: {
      letterSpacing: ".00488em"
    }
  }, "s"), _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan878",
    x: 98.103,
    y: 154.042
  }, "se"))), /*#__PURE__*/React.createElement("g", {
    id: "g902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line882",
    d: "M73.547 142.724h31.707",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line892",
    d: "M73.26 142.724h32.279",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g937",
    transform: "translate(0 -7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text920",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(22.21 196.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan906",
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.02832em"
    }
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan908",
    x: 3.821,
    y: 0,
    style: {
      letterSpacing: "-.01416em"
    }
  }, "r"), _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan910",
    x: 6.053,
    y: 0
  }, "eie")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan912",
    x: 17.073,
    y: 0,
    style: {
      letterSpacing: "-.02686em"
    }
  }, "F"), _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan914",
    x: 20.904,
    y: 0
  }, "ah")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan916",
    x: 28.557,
    y: 0,
    style: {
      letterSpacing: ".03125em"
    }
  }, "r"), _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan918",
    x: 31.107,
    y: 0
  }, "t")))), /*#__PURE__*/React.createElement("g", {
    id: "g935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line923",
    d: "M23.485 172.15h32.279",
    style: {
      fill: "none",
      stroke: "#eb0000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line925",
    d: "M23.485 180.994h32.279",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line927",
    d: "M23.486 185.415h32.279",
    style: {
      fill: "none",
      stroke: "#2a6698",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line929",
    d: "M23.772 176.572h31.707",
    style: {
      fill: "none",
      stroke: "#3b3b3b",
      strokeWidth: "1.98425px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "line931",
    d: "M23.485 176.572h32.279",
    style: {
      fill: "none",
      stroke: "#fbd700",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g1048",
    transform: "translate(-50.12 -7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text402292-9-5-9-7",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1043",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(121.818 196.83)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1021",
    x: 0,
    y: 0,
    style: {
      letterSpacing: "-.02588em"
    }
  }, "K"), _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1023",
    x: 4.488,
    y: 0
  }, "eine")), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1025",
    x: 0,
    y: 8.4
  }, "E")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1027",
    x: 4.276,
    y: 8.4,
    style: {
      letterSpacing: ".00439em"
    }
  }, "r"), _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1029",
    x: 6.638,
    y: 8.4
  }, "m\xE4")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1031",
    x: 16.369,
    y: 8.4,
    style: {
      letterSpacing: ".00488em"
    }
  }, "s"), _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1033",
    x: 19.903,
    y: 8.4
  }, "s")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1035",
    x: 23.403,
    y: 8.4,
    style: {
      letterSpacing: "-.00146em"
    }
  }, "i"), _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1037",
    x: 24.948,
    y: 8.4
  }, "gu")), /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1039",
    x: 32.86,
    y: 8.4,
    style: {
      letterSpacing: "-.00244em"
    }
  }, "n"), _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1041",
    x: 36.736,
    y: 8.4
  }, "g")))), /*#__PURE__*/React.createElement("path", {
    id: "line1046",
    d: "M122.891 185.415h32.28",
    style: {
      fill: "none",
      stroke: "#999",
      strokeWidth: "1.41732px",
      strokeLinecap: "square",
      strokeMiterlimit: 3
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "state-publisher"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text2350",
    style: {
      isolation: "isolate"
    },
    transform: "translate(7.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1052",
    style: {
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      isolation: "isolate"
    },
    transform: "translate(51.046 128.648)"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1050",
    x: 0,
    y: 0
  }, "***publishedAt***")))), /*#__PURE__*/React.createElement("g", {
    id: "text2347",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "text1057",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 7,
      fontFamily: "SBBWeb-Roman,&quot",
      InkscapeFontSpecification: "&quot",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      isolation: "isolate"
    },
    transform: "translate(22.21 128.648)"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan1034",
    x: 0,
    y: 0
  }, "Erstellt am")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkLegendA3De);
export default __webpack_public_path__ + "static/media/tk_legend_a3_de.2740cd0e0e4950099fd18fb8e1cda359.svg";
export { ForwardRef as ReactComponent };